import React from 'react';
import AnalyticsDashboard from '../analytics/AnalyticsDashboard';

/**
 * Replaces the old static stats panel with a full analytics dashboard
 * powered by /api/analytics/dashboard. The component fetches its own data
 * from the immutable analytics_events journal, so it remains accurate even
 * after auto-cleanup deletes old jobs and rejects old applications.
 *
 * `applications` is intentionally ignored here — the analytics endpoint
 * sources from events and supplemental joins on the backend.
 */
const StatsView = () => (
  <div className="space-y-4">
    <AnalyticsDashboard />
  </div>
);

export default StatsView;
